import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './REVSHARE_Revenue_Source.css';

const REVSHARE_Revenue_Source = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"REVSHARE_REVENUE_SOURCE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	REVSHARE_REVENUE_SOURCE:-1
  });


  const [REVSHARE_REVENUE_SOURCE, setREVSHARE_REVENUE_SOURCE] = React.useState(null);
  const [REVSHARE_REVENUE_SOURCE_D, setREVSHARE_REVENUE_SOURCE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Revenue Share Revenue Source');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/REVSHARE_Revenue_Source',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewREVSHARE_REVENUE_SOURCE(clientInfo,"OpenNew");

		navigate('/REVSHARE_Revenue_Source',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/REVSHARE_Revenue_Source_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutREVSHARE_REVENUE_SOURCE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostREVSHARE_REVENUE_SOURCE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewREVSHARE_REVENUE_SOURCE(clientInfo,"OpenNew");
		}
		navigate('/REVSHARE_Revenue_Source',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/REVSHARE_Revenue_Source_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/REVSHARE_Revenue_Source_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/REVSHARE_Revenue_Source_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
		if(Temp_Data2.status!="New"){
			handleDeleteREVSHARE_REVENUE_SOURCE(Temp_Data2);
			navigate('/REVSHARE_Revenue_Source#New',{replace:true});
		} 
		else 
			navigate('/REVSHARE_Revenue_Source',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/REVSHARE_Revenue_Source',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/REVSHARE_Revenue_Source',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/REVSHARE_Revenue_Source',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/REVSHARE_Revenue_Source',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!REVSHARE_REVENUE_SOURCE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_${i}_SECTION`;
	  const headerId = `#REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [REVSHARE_REVENUE_SOURCE]) ;


  
  
  var Ids = [];
  for(var Ele in REVSHARE_REVENUE_SOURCE){
	  for(var Sec in REVSHARE_REVENUE_SOURCE[Ele]){
		if(Sec == "id")
			Ids.push(REVSHARE_REVENUE_SOURCE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(REVSHARE_REVENUE_SOURCE[Ele]["status"]);
		else if(Array.isArray(REVSHARE_REVENUE_SOURCE[Ele][Sec]))
			  for(var Row in REVSHARE_REVENUE_SOURCE[Ele][Sec])  // Convert to REVSHARE_REVENUE_SOURCE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in REVSHARE_REVENUE_SOURCE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["REVSHARE_REVENUE_SOURCE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewREVSHARE_REVENUE_SOURCE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_REVENUE_SOURCE`).then((response1) => {
		if(!REVSHARE_REVENUE_SOURCE) 
			setREVSHARE_REVENUE_SOURCE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_REVENUE_SOURCE_D`).then((response2) => {
			setREVSHARE_REVENUE_SOURCE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddREVSHARE_REVENUE_SOURCE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewREVSHARE_REVENUE_SOURCE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_REVENUE_SOURCE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setREVSHARE_REVENUE_SOURCE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataREVSHARE_REVENUE_SOURCE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_REVENUE_SOURCE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutREVSHARE_REVENUE_SOURCE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_REVENUE_SOURCE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostREVSHARE_REVENUE_SOURCE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_REVENUE_SOURCE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteREVSHARE_REVENUE_SOURCE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/REVSHARE_REVENUE_SOURCE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["1"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_0"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("1","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_0",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["1"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_1"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("1","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_1",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["1"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_2"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("1","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_2",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  

const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["1"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_3"]=value;
	Form_Data_onChange("1","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_3",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
  }; 
  

    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["1"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_4"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("1","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_4",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["2"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_0"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("2","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_0",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["2"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_1"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("2","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_1",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["3"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_0"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("3","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_0",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  

const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["3"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_1"]=value;
	Form_Data_onChange("3","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_1",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
  }; 
  


const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["4"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_0"]=value;
	Form_Data_onChange("4","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_0",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
  }; 
  


const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["9"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_0"]=value;
	Form_Data_onChange("9","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_0",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
  }; 
  

    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["9"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_1"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("9","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_1",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["9"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_2"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("9","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_2",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["9"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_3"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("9","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_3",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  
    
const REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
	Temp_Data["9"]["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_4"]=value;
	//handleAddREVSHARE_REVENUE_SOURCE(Temp_Data,App_Data['REVSHARE_REVENUE_SOURCE']);
	Form_Data_onChange("9","REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_4",value,Temp_Data);
 	//handleLastDataREVSHARE_REVENUE_SOURCE(Temp_Data);
    setREVSHARE_REVENUE_SOURCE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!REVSHARE_REVENUE_SOURCE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedREVSHARE_REVENUE_SOURCE =JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
  updatedREVSHARE_REVENUE_SOURCE[Sec] = [...updatedREVSHARE_REVENUE_SOURCE[Sec], newRow];
  setREVSHARE_REVENUE_SOURCE(updatedREVSHARE_REVENUE_SOURCE);
};

const handleDeleteRow = (sec,index) => {
  const updatedREVSHARE_REVENUE_SOURCE = JSON.parse(JSON.stringify(REVSHARE_REVENUE_SOURCE));
  updatedREVSHARE_REVENUE_SOURCE[sec].splice(index, 1);
  setREVSHARE_REVENUE_SOURCE(updatedREVSHARE_REVENUE_SOURCE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Revenue Share Revenue Source`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Revenue Share Source ID`)} <span className="toggle-icon">^</span></h2>
            <div id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`REVSHARE Revenue Source ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_0" type="text" className="form-control" placeholder="REVSHARE Revenue Source ID" value={REVSHARE_REVENUE_SOURCE["1"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_0`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter REVSHARE Revenue Source ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_1" type="text" className="form-control" placeholder="Asset ID" value={REVSHARE_REVENUE_SOURCE["1"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_1`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_2" type="text" className="form-control" placeholder="Offering ID" value={REVSHARE_REVENUE_SOURCE["1"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_2`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Revenue Source Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_3"  value={REVSHARE_REVENUE_SOURCE["1"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_3`]} onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_3_Change} className="form-control" name="Revenue Source Type"  >
						  <option value="Rental Revenue">Rental Revenue</option>
						  <option value="Business Revenue">Business Revenue</option>
						  <option value="Parking Revenue">Parking Revenue</option>
						  <option value="Storage Revenue">Storage Revenue</option>
						  <option value="Advertising Revenue">Advertising Revenue</option>
						  <option value="Hotel Revenue">Hotel Revenue</option>
						  <option value="Industrial Revenue">Industrial Revenue</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Revenue Source Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Revenue Source Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_4" type="text" className="form-control" placeholder="Revenue Source Name" value={REVSHARE_REVENUE_SOURCE["1"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_4`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Revenue Source Name`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Gross Revenue Definition`)} <span className="toggle-icon">^</span></h2>
            <div id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Gross Revenue Definition`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_0" type="text" className="form-control" placeholder="Gross Revenue Definition" value={REVSHARE_REVENUE_SOURCE["2"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_0`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Gross Revenue Definition`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Net Revenue Definition`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_1" type="text" className="form-control" placeholder="Net Revenue Definition" value={REVSHARE_REVENUE_SOURCE["2"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_1`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Net Revenue Definition`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Excluded Revenue Items`)} <span className="toggle-icon">^</span></h2>
            <div id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Excluded Revenue Items`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_0" type="text" className="form-control" placeholder="Excluded Revenue Items" value={REVSHARE_REVENUE_SOURCE["3"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_0`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Excluded Revenue Items`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Revenue Verification Method`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_1"  value={REVSHARE_REVENUE_SOURCE["3"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_1`]} onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_3_1_Change} className="form-control" name="Revenue Verification Method"  >
						  <option value="Bank Statement">Bank Statement</option>
						  <option value="Accounting Report">Accounting Report</option>
						  <option value="POS Report">POS Report</option>
						  <option value="Manager Certification">Manager Certification</option>
						  <option value="Third-Party Audit">Third-Party Audit</option>
						  <option value="API Integration">API Integration</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Revenue Verification Method
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Revenue Source Status`)} <span className="toggle-icon">^</span></h2>
            <div id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Revenue Source Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_0"  value={REVSHARE_REVENUE_SOURCE["4"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_0`]} onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_4_0_Change} className="form-control" name="Revenue Source Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Suspended">Suspended</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Revenue Source Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_0"  value={REVSHARE_REVENUE_SOURCE["9"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_0`]} onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_1" type="text" className="form-control" placeholder="Created By" value={REVSHARE_REVENUE_SOURCE["9"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_1`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_2" type="text" className="form-control" placeholder="Created At" value={REVSHARE_REVENUE_SOURCE["9"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_2`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_3" type="text" className="form-control" placeholder="Updated By" value={REVSHARE_REVENUE_SOURCE["9"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_3`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_4" type="text" className="form-control" placeholder="Updated At" value={REVSHARE_REVENUE_SOURCE["9"][`REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_4`]} 
						onChange={REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["REVENUE_SHARE_01_ASSET_OWNER_SPONSOR_REVENUE_SETUP_REVSHARE_REVENUE_SOURCE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default REVSHARE_Revenue_Source;  